__turbopack_context__.v({
  "className": "plus_jakarta_sans_77106e1b-module__2GBMBq__className",
  "variable": "plus_jakarta_sans_77106e1b-module__2GBMBq__variable",
});
